import fetchJson, { fetchFile } from './fetchJson';
import getCdnUrl from './getCdnUrl';
import { DEV_CDN_DOMAIN, DEV_RESPONSE_PATH } from '../constants';

const SESSION_QUERY = `query GetOnScreenHelpData($sessionId: String, $featureCodes: [CftFeatureInput]) {
  onScreenHelp(sessionId: $sessionId) {
    sessionData {
        brandinglogo
        defaultLogoUsed
    }
  }
  cft {
    features(inputs: $featureCodes) {
      code
      value
    }
  }
}`;

function handleResponse(response) {
    // Fix casing of api response
    const {
        brandinglogo: brandingLogo,
        defaultLogoUsed,
    } = response.data.onScreenHelp.sessionData;

    // Flatten features for easier access.
    const cftResults = response.data.cft?.features || [];
    const features = Object.fromEntries(cftResults.map(({ code, value }) => [code, value]));

    return {
        brandingLogo,
        defaultLogoUsed,
        isCompleteUser: features?.['castle/isCompleteUser'],
    };
}

export function fetchOnScreenHelpDevData(devResponse) {
    let cdnUrl = getCdnUrl(__webpack_public_path__);
    if (cdnUrl?.indexOf('localhost') !== -1) {
        cdnUrl = DEV_CDN_DOMAIN;
    }
    const url = `${cdnUrl}${DEV_RESPONSE_PATH}${devResponse}.json`;

    return fetchFile(url)
        .then((response) => handleResponse(response));
}

export default function fetchOnScreenHelpData(apiContext, graphQlQueryArgs, correlationId) {
    if (!apiContext) {
        throw new Error('fetchOnScreenHelpData requires an apiContext');
    }

    const query = {
        query: SESSION_QUERY,
        variables: graphQlQueryArgs,
    };

    return fetchJson(apiContext, query, correlationId)
        .then((response) => handleResponse(response));
}
